// extracted by mini-css-extract-plugin
export default {"heading1":"gntNlF_FkrIHEHQLcmJS","heading2":"qnkI4qSFraj2vs_Z37eA","heading3":"jxEuXtvxCZfNwwJnOyzx","paragraph":"_7m4MQrtZGo3Xo8DMh5Y","custom":"eZc9EADcGCtnlrNomYm9"};